import { TranslatePipe } from "@ngx-translate/core";
import { AngularSvgIconModule } from "angular-svg-icon";

import { Component, computed, inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";

import { Prefix } from "../../../pages/ip-prefixes/ip-prefixes.types";
import { AuthService } from "../../../services/authservice";
import { AffectedService } from "../../malfunction/malfunction-card/components/affected-service/affected-service";

interface SubscriptionWithProduct {
  customerDescription: string;
  customerId: string;
  product: { type: string; tag: string };
  subscriptionId: string;
}

export interface DialogIPPrefixesInput {
  editModus: boolean;
  prefix: Prefix;
  linkedSubscriptions: SubscriptionWithProduct[];
}

@Component({
  selector: "dialog-ip-prefixes",
  templateUrl: "dialog-ip-prefixes.html",
  imports: [AffectedService, AngularSvgIconModule, TranslatePipe],
})
export class DialogIPPrefixesComponent {
  data = inject<DialogIPPrefixesInput>(MAT_DIALOG_DATA);
  dialogRef = inject<MatDialogRef<DialogIPPrefixesComponent>>(MatDialogRef);

  auth = inject(AuthService);

  protected editMode = computed(() => this.data.editModus || false);
  protected linkedServices = computed(() => this.data.linkedSubscriptions ?? []);

  protected editAction = computed(() =>
    this.editMode() ? { action: "addPrefix", selectedPrefix: this.data.prefix } : undefined,
  );

  isAvailable(subscription: { customerId: string }) {
    return this.auth.viewingCustomer().customerId === subscription.customerId;
  }

  closeDialog(forceScrollTop: boolean = false): void {
    this.dialogRef.close({ forceScrollTop });
  }
}
